import React from "react";
import { Container } from "reactstrap";
import VVSTable from "components/form-control/VVSTable";

const CallReport = () => {
  return (
    <div className="page-content">
      <Container fluid>
        <VVSTable
          name="HistoryCallLog"
          title="Lịch sử cuộc gọi"
          disableAdd
          disableDelete
        />
      </Container>
    </div>
  );
};

export default CallReport;
